import ColorModeSection from "./ColorModeSection";
import ZoomSection from "./ZoomSection";
import RoundedCornersSection from "./RoundedCornersSection";
import ThemeSection from "./ThemeSection";

/**
 * The Appearance settings body. Rendered by AppearanceTab (legacy accordion)
 * and SettingsCategoryView (flag `settingsMiddleViews`). Layout-neutral
 * fragment — the host owns the wrapper.
 */
export default function AppearanceContent() {
  return (
    <>
      {/* COLOR MODE */}
      <ColorModeSection />

      {/* THEME */}
      <ThemeSection />

      {/* ZOOM */}
      <ZoomSection />

      {/* BORDER RADIUS */}
      <RoundedCornersSection />
    </>
  );
}
